import { isString, isEmail, isEmpty } from '@nmx/utils-frontend/dist/utilities/validators';
import Session from '@nmx/utils-frontend/dist/utilities/frontend/session';

// Name must start with a letter and end with a letter or dot.
// Can have letters including accent, apostrophe, space, dot and dash.
const nameIsValidForLeadsSystem = (name) => {
  // regex to restrict bad chars, and only allow upper/lower case letters, accents, apostrophes, spaces, dots, and dashes.
  const nameTest = /^[a-zA-Z\u00C0-\u024F'. -]{0,100}$/.test(name);
  if (!nameTest) {
    return false;
  }
  // capture first character of string. Name MUST start with a letter.
  const firstChar = name.charAt(0);
  const firstCharTest = /^[a-zA-Z\u00C0-\u024F]$/.test(firstChar);
  // throw error if name ends in something other than a letter
  if (!firstCharTest) {
    return false;
  }
  // capture last character of string
  const lastChar = name.slice(-1);
  const lastCharTest = /^[a-zA-Z\u00C0-\u024F.]$/.test(lastChar);
  // throw error if name ends in something other than a letter or a dot
  if (!lastCharTest) {
    return false;
  }

  return true;
};

// TRUE IS BAD
export const validateFirstName = (name) => {
  let res = [false, ''];
  if (isEmpty(name) || !isString(name)) {
    res = [true, 'Enter first name'];
  }
  if (name.length > 150) {
    res = [true, 'Exceeded character limit'];
  }
  if (!nameIsValidForLeadsSystem(name)) {
    res = [true, 'Enter valid name.'];
  }

  return res;
};

export const validateLastName = (name) => {
  let res = [false, ''];
  if (isEmpty(name) || !isString(name)) {
    res = [true, 'Enter last name'];
  }
  if (name.length > 150) {
    res = [true, 'Exceeded character limit'];
  }
  if (!nameIsValidForLeadsSystem(name)) {
    res = [true, 'Enter valid name.'];
  }
  return res;
};

export const validateEmail = (email) => {
  let res = [false, ''];
  if (isEmpty(email)) {
    res = [true, 'Enter email'];
  } else if (!isEmail(email)) {
    res = [true, 'Enter valid email address'];
  }
  return res;
};

export const buildPreleadPayload = (
  values,
  recaptchaReponseToken,
  journey,
) => ({
  firstName: values.firstName,
  lastName: values.lastName,
  email: values.email,
  source: 'NM.com',
  topic: 'Suspect Email Capture', // Update this??? Is this a good value?
  channel: 'website',
  recaptcha_response_token: recaptchaReponseToken,
  journey,
  utm_campaign: Session.get('utmCampaign'),
  utm_content: Session.get('utmContent'),
  utm_medium: Session.get('utmMedium'),
  utm_source: Session.get('utmSource'),
  utm_term: Session.get('utmTerm'),
});

